$(function() {
		$('.recom-slide .slider').slick({
			arrows: true, // 前後の矢印非表示
      dots: true,
			centerMode: false, //センターモード
			//centerPadding: '300px', //前後のパディング
			autoplay: false, //オートプレイ
      autoplaySpeed: 0,
      variableWidth: true,
			slidesToShow: 1, 
			responsive: [{
				breakpoint: 768,
				settings: {
					arrows: true, // 前後の矢印非表示
					centerMode: false,
					slidesToShow: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					arrows: true, // 前後の矢印非表示
					centerMode: false,
					slidesToShow: 1
				}
			}]
		});
	});
$(function() {
		$('.flow-slide .slider').slick({
			arrows: true, // 前後の矢印非表示
      dots: true,
			centerMode: false, //センターモード
			//centerPadding: '300px', //前後のパディング
			autoplay: false, //オートプレイ
      autoplaySpeed: 0,
      variableWidth: true,
			slidesToShow: 3, 
			responsive: [{
				breakpoint: 768,
				settings: {
					arrows: true, // 前後の矢印非表示
					centerMode: false,
					slidesToShow: 3
				}
			},
			{
				breakpoint: 480,
				settings: {
					arrows: true, // 前後の矢印非表示
					centerMode: false,
					slidesToShow: 1
				}
			}]
		});
	});
$(function() {
		$('.standard-slide .slider').slick({
			arrows: true, // 前後の矢印非表示
      dots: false,
			centerMode: false, //センターモード
			//centerPadding: '300px', //前後のパディング
			autoplay: false, //オートプレイ
      autoplaySpeed: 0,
      variableWidth: true,
			slidesToShow: 1, 
			responsive: [{
				breakpoint: 768,
				settings: {
					arrows: true, // 前後の矢印非表示
					centerMode: false,
					slidesToShow: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					arrows: true, // 前後の矢印非表示
					centerMode: false,
					slidesToShow: 1
				}
			}]
		});
	});